var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-topbar" },
    [
      _vm.showHamburger
        ? _c(
            "button",
            {
              staticClass: "nav-topbar__hamburger",
              attrs: { type: "button", title: "Menu" },
              on: {
                click: function($event) {
                  return _vm.$emit("toggle-menu")
                }
              }
            },
            [
              _c("icon-svg", {
                attrs: { name: "mdi-menu", size: 20, color: "#030309" }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "nav",
        { staticClass: "nav-topbar__crumb" },
        [
          _vm.isCliente && _vm.clientName
            ? [
                _c("span", { staticClass: "nav-topbar__client-avatar" }, [
                  _vm._v(_vm._s(_vm.clientInitials))
                ]),
                _c("span", { staticClass: "nav-topbar__client-name" }, [
                  _vm._v(_vm._s(_vm.clientName))
                ])
              ]
            : _vm._e(),
          _c("TeleportTarget", {
            staticClass: "nav-topbar__inicio",
            attrs: { name: "topbar-inicio" }
          })
        ],
        2
      ),
      _c("div", { staticClass: "nav-topbar__spacer" }),
      _vm.showSearch
        ? _c(
            "BaseButton",
            {
              staticClass: "nav-topbar__search",
              attrs: {
                "fit-content": "",
                "aria-label":
                  "Buscar páginas, ações ou clientes (" +
                  _vm.searchShortcutLabel +
                  ")"
              },
              nativeOn: {
                click: function($event) {
                  return _vm.openSearch($event)
                }
              }
            },
            [
              _c("icon-svg", {
                attrs: { name: "search", size: 16, color: "secondary" }
              }),
              _c("span", { staticClass: "nav-topbar__search-placeholder" }, [
                _vm._v("Buscar")
              ]),
              _c("span", { staticClass: "nav-topbar__search-kbd" }, [
                _vm._v(_vm._s(_vm.searchShortcutLabel))
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "nav-topbar__actions" },
        [
          _c("span", { staticClass: "nav-topbar__date" }, [
            _vm._v(_vm._s(_vm.today))
          ]),
          _c("TopbarNotifications"),
          _c("TopbarUserMenu")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }